import { render, staticRenderFns } from "./InstallmentsDetails.vue?vue&type=template&id=ad9f4d36&"
import script from "./InstallmentsDetails.vue?vue&type=script&lang=js&"
export * from "./InstallmentsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports